export default __webpack_public_path__ + "static/media/logoWhiteXS.f0b4fff0.webp";